import { CardElement } from '@stripe/react-stripe-js';
import { StripeCardElementChangeEvent } from '@stripe/stripe-js';
import { Box, Checkbox, VStack } from '@televet/kibble-ui';
import React from 'react';
import SavedPaymentMethods from 'shared/components/SidePanel/components/InvoicingPanel/components/SavedPaymentMethods';
import { PaymentMedium } from 'shared/types/graphql';
import { defaultCardValidationState } from '../utils/paymentEnumsAndVariables';
import ErrorInstructionComponent from './ErrorInstruction';
import FieldTitleComponent from './FieldTitleComponent';

interface IManualPaymentProps {
  currentPaymentMedium: PaymentMedium;
  isValid: typeof defaultCardValidationState;
  isCardSetForSaving: boolean;
  handleChangeCreditCard: (e: StripeCardElementChangeEvent) => void;
  setIsCardSetForSaving: (isCardSetForSaving: boolean) => void;
  validationMessage: string;
  clinicPetParentId: string;
  selectedSavedPaymentMethodStripeId: string | null;
  setSelectedSavedPaymentMethodStripeId: React.Dispatch<React.SetStateAction<string | null>>;
}

const ManualPayment = ({
  currentPaymentMedium,
  selectedSavedPaymentMethodStripeId,
  isValid,
  isCardSetForSaving,
  handleChangeCreditCard,
  setIsCardSetForSaving,
  validationMessage,
  clinicPetParentId,
  setSelectedSavedPaymentMethodStripeId,
}: IManualPaymentProps): JSX.Element => {
  const showComponent = currentPaymentMedium === PaymentMedium.StripeVirtualTerminal;
  return (
    <>
      {showComponent && (
        <VStack alignItems="stretch">
          {!selectedSavedPaymentMethodStripeId && (
            <Box className="Payment__Wrapper-Card-Input" pb="2">
              <Box pt="4" pb="2">
                <FieldTitleComponent fieldTitleText="Card Details " isRequired />
              </Box>
              <Box
                className="Payment__Wrapper-Card-Element"
                border="1px"
                borderRadius="md"
                width="100%"
                height="10"
                pl="2"
                pt="2.5"
              >
                <CardElement
                  options={{
                    style: {
                      base: {
                        fontSize: 'md',
                      },
                    },
                  }}
                  onChange={(e: StripeCardElementChangeEvent): void => handleChangeCreditCard(e)}
                />
              </Box>

              {isValid.card && (
                <Box className="Payment__Manual-Saving-Payment-Method-Option" width="100%" pt="3">
                  <Checkbox
                    isChecked={isCardSetForSaving}
                    onChange={(): void => {
                      setIsCardSetForSaving(!isCardSetForSaving);
                    }}
                  >
                    Save this card for future use
                  </Checkbox>
                </Box>
              )}
            </Box>
          )}
          <Box pt={selectedSavedPaymentMethodStripeId ? 3 : 0}>
            <SavedPaymentMethods
              clinicPetParentId={clinicPetParentId}
              selectedSavedPaymentMethodStripeId={selectedSavedPaymentMethodStripeId}
              setSelectedSavedPaymentMethodStripeId={setSelectedSavedPaymentMethodStripeId}
            />
          </Box>
          {!!validationMessage && validationMessage?.length > 0 && (
            <Box mx="5">
              <ErrorInstructionComponent errorText={validationMessage} />
            </Box>
          )}
        </VStack>
      )}
    </>
  );
};

export default ManualPayment;
